<template>
    <div class="web_home">
        <!-- md -->
        <div class="md_box pc_box" >
            <div class="md_top_nav" v-if="$store.state.detailsbottom">
                <img class="img_box" src="../../assets/icons/官网首页_slices/LOGO2.png" alt="" srcset="">
                <img @click="opennav" class="md_nav_img" src="../../assets/icons/官网首页_slices/菜单栏@3x.png" alt="">
            </div>
            <el-drawer
                title=""
                :visible.sync="drawer"
                size="45%">
                <div class="md_nav_list">
                    <div 
                        class="md_nav_item" 
                        :class="item.id==$store.state.mdnavaction?'nav_active':''"
                        v-for="(item,index) in mdnav" 
                        :key="index" 
                        @click="mdnavclick(item)">
                        {{ item.title }}
                    </div>
                </div>
            </el-drawer>
            <div class="md_content" ref="content">
                <mdindex 
                    :list="list"
                    :corelist="corelist"
                    :data_change="data_change"
                    @cusscroll="handleScroll" 
                    v-if="$store.state.mdnavaction==0"></mdindex>
                <mdproser  v-if="$store.state.mdnavaction==1"></mdproser>
                <mdhr  v-if="$store.state.mdnavaction==2"></mdhr>
                <mdcases v-if="$store.state.mdnavaction==3"></mdcases>
                <mdhor  v-if="$store.state.mdnavaction==4"></mdhor>
                <mdabout v-if="$store.state.mdnavaction==5"></mdabout>
            </div>
        </div>
        <!-- pc -->
        <div class="swiper_box adaptation" >
            <swiper v-if="list.length>0" :options="swiperOption" ref="mySwiper" class="swiper_top_box">
                <swiper-slide v-for="(item, index) in list" :key="index">
                    <img :src="item" alt="" />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <div class="swiper_bar_box">
                <div class="company_logo">
                    <img class="img_logo" src="../../assets/icons/官网首页_slices/LOGO1.png" alt="">
                </div>
                <div class="bar_box">
                    <div class="bar_botton bar_botton_magrin" @click="barclick(item)" v-for="(item,index) of barlist" :key="index">
                        {{ item.title }}
                    </div>
                </div>
            </div>
        </div>
        <div class="data_change adaptation">
            <div class="data_item_box" v-for="(item,index) of data_change" :key="index">
                <countTo 
                    class="count_box" 
                    :startVal='0' 
                    separator=""
                    :endVal='Number( item.number)' 
                    :duration='3000'></countTo>
           
                <div class="title">{{ item.title }}</div>
                <div class="little_title">{{ item.description }}</div>
            </div>
        </div>
        <div class="homepage adaptation">
            <div class="web_index_img_box"></div>
        </div>
        <div class="pro_ana_ser adaptation">
            <div class="pas_title">婧贤人才产品与服务</div>
            <div class="pas_item_box">
                <div  class="box"  v-for="(item,index) in proandserlist" :key="index">
                    <img class="img_box" 
                        :src="item.bg" alt="">
                    <div class="two_box" >
                        <img 
                            class="two_img_box" 
                            :src="item.icon" alt="" srcset="">
                        <div class="two_font">
                            {{ item.title }}
                        </div>
                        <div class="two_font_title">
                            {{ item.subtitle }}
                        </div>
                        <div class="two_botton" @click="seedetails(item)">
                            查看详情
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="case_box adaptation">
            <div class="case_title">服务案例</div>
            <swiper v-if="corelist.length>0" :options="swiperOption1" ref="mySwiper1" class="swiper_two_box">
                <swiper-slide v-for="(item, index) in corelist" :key="index" >
                    <img class="swiper_case_img" :src="item.resource" alt=""/>
                    <div class="font_box">
                        <div class="font_brief">{{  item.title }}</div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="swiper_left">
                <img src="../../assets/icons/官网首页_slices/left.png" alt="" srcset="">
            </div>
            <div class="swiper_right">
                <img src="../../assets/icons/官网首页_slices/right.png" alt="" srcset="">
            </div>
        </div>
         <div class="core_values adaptation">
            <div class="cv_title">核心价值</div>
            <div class="cv_item_box">
               <div class="item_box" v-for="(item,index) in worth" :key="index">
                    <div class="item_top_box">
                        <img class="core_img_box" 
                            :src="item.icon" alt="">
                        <div class="core_font_box">{{ item.title }}</div>
                    </div>
                    <div class="item_content" v-html="item.content"></div>
               </div>
            </div>
        </div>
        <flexbotton></flexbotton>
        <div class="bottom adaptation">        
            <div class="bottom_interior">
                <div class="unveil unfold">
                    <div class="title">产品与服务</div>
                    <div class="subtitle" 
                        v-for="(item,index) of botNavigationlist" :key="index"
                        @click="botNavigation(item)">{{ item.title }}</div>
                </div>
                <div class="unveil news">
                    <div class="title">关于婧贤</div>
                    <div class="subtitle" 
                        v-for="(item,index) of aboutlist" :key="index"
                        @click="botNavigation(item)">{{ item.title }}</div>
                </div> 
                <div class="unveil about">
                    <div class="title">联系我们</div>
                    <div class=" increase">拉萨总部：拉萨经济技术开发区工业中心2期</div>
                    <div class=" increase">联系电话：17354516359</div>
                    <div class=" increase">电子邮箱：service@xzjxrl.com</div>
                    <div class=" increase">企业微信：17354516359</div>
                </div>
            </div>
            <div class="authorize">
                <div class="por">
                    <div>版权所有：西藏婧贤人力资源管理有限公司</div>
                    <a :href="'http://'+'beian.miit.gov.cn/'" target="_blank">藏 ICP 备 2025003038 号-1</a>
                    <div class="nat_box">
                        <img class="nat_img_box" src="../../assets/icons/官网首页_slices/national.png" alt="">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=54010002000200" rel="noreferrer" target="_blank">藏公网安备54010002000200号</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import mdindex from './md/index.vue'
import mdabout from './md/about.vue'
import mdcases from './md/cases.vue'
import mdhr from './md/hr.vue'
import mdproser from './md/proser.vue'
import mdhor from './md/recruitment.vue'
import flexbotton from '../../components/flexbotton.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import countTo from 'vue-count-to';
import "swiper/dist/css/swiper.css";
export default{
    components: { 
        flexbotton,swiper,swiperSlide,countTo,mdindex,
        mdabout,mdcases,mdhr,mdproser,mdhor
    },
    data(){
        return{
            list:[],
            swiperOption1:{
                slidesPerView: 'auto',
                loop: true,
                spaceBetween:25,
                navigation: {
                    nextEl: ".swiper_left",
                    prevEl: ".swiper_right",
                }, 
                autoplay: {
                    delay: 2000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
            },
            swiperOption: {
                loop: true,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                // 显示分页
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, 
                },
            },
            barlist:[
                {id:1,title:'产品与服务',path:'/proser'},
                {id:2,title:'HR数字化转型',path:'/hr'},
                {id:3,title:'服务案例',path:'/cases'},
                {id:4,title:'招聘信息',path:'/horecruitmentme'},
                {id:5,title:'关于婧贤',path:'/about'},
            ],
            botNavigationlist:[
                {title:'人力资源外包',path:'/proser',type:1,},
                {title:'劳务派遣服务',path:'/proser',type:2,},
                {title:'岗位外包服务',path:'/proser',type:3,},
                {title:'HR数字化转型',path:'/hr'},
            ],
            aboutlist:[
                {title:'产品与服务',path:'/proser'},
                {title:'服务案例',path:'/cases'},
                {title:'联系我们',path:'/about'},
            ],
            proandserlist:[
                {
                    type:1,
                    id:1,
                    path:'/proser',
                    title:'人力资源事务外包',
                    subtitle:'有效地提高效率，并使外包职能的运作更加专业化。',
                    icon:require('../../assets/icons/官网首页_slices/hr.png'),
                    bg:require('../../assets/icons/官网首页_slices/1.png')
                },
                {   
                    type:2,
                    id:1,
                    path:'/proser',
                    title:'劳务派遣服务',
                    subtitle:'灵活用工形式，劳动力的使用和管理分离。',
                    icon:require('../../assets/icons/官网首页_slices/labor.png'),
                    bg:require('../../assets/icons/官网首页_slices/2.png')
                },
                {
                    type:3,
                    id:1,
                    path:'/proser',
                    title:'岗位外包服务',
                    subtitle:'降低成本、提高效率、优化资源配置。',
                    icon:require('../../assets/icons/官网首页_slices/post.png'),
                    bg:require('../../assets/icons/官网首页_slices/3.png')
                },
                {
                    type:1,
                    id:2,
                    path:'/hr',
                    title:'HR数字化转型',
                    subtitle:'以颠覆性力量重构人力资源管理逻辑。',
                    icon:require('../../assets/icons/官网首页_slices/evolve.png'),
                    bg:require('../../assets/icons/官网首页_slices/4.png')
                },
            ],
            data_change:[
                {number: 2,title:'双城运行',littletitle: '成都拉萨双中心'},
                {number: 40,title:'服务机构',littletitle: '共计服务机构40余家'},
                {number: 9527,title:'输送人才',littletitle: '输送外包人员9千+'},
            ],
            corelist:[],
            worth:[
                {
                    icon:require('../../assets/icons/官网首页_slices/value_01.png'),
                    title:'使命',
                    content:'以人为本，以服务为先</br>成就人才价值，助力企业腾飞'
                },
                {
                    icon:require('../../assets/icons/官网首页_slices/value_02.png'),
                    title:'愿景',
                    content:'依托人才与科技</br>成为人力资源服务行业数字赋能与科技创新引领者'
                },
                {
                    icon:require('../../assets/icons/官网首页_slices/value_03.png'),
                    title:'价值观',
                    content:'人尽其才，才尽其用'
                },
            ],
            drawer:false,
            mdnav:[
                {id:0,title:'首页'},
                {id:1,title:'产品与服务'},
                {id:2,title:'HR数字化转型'},
                {id:3,title:'服务案例'},
                {id:4,title:'招聘信息'},
                {id:5,title:'关于婧贤'},
            ],
            navaction:0,
        }
    },
    created(){
            // alert(window.innerWidth  )
        //    alert('kuan'+window.innerWidth,'gao'+window.innerHeight )
       if(this.$store.state.mdnavaction!=null){
        this.navaction=this.$store.state.mdnavaction
       }
       this.$store.commit('mdnavaction',this.navaction)
    //   window.addEventListener('resize', this.updateWindowDimensions);
    },
    mounted(){
      this.axioslist()
        // this.navaction=this.mdnav[0].id
    },
    methods:{ 
       updateWindowDimensions() {
            //  console.log('尺寸变化',document.documentElement.clientWidth,750<document.documentElement.clientWidth&& document.documentElement.clientWidth<=1080);
            // // alert(document.documentElement.clientWidth)
            // if(750<document.documentElement.clientWidth&& document.documentElement.clientWidth<=1080){
            //     this.$router.push('/magic')
            // }else{
            //     this.$router.push('/')
            // }
       },
        handleScroll(){
            this.$refs.content.scrollTop=0
        },
        mdnavclick(item){
            this.$refs.content.scrollTop=0
            // this.navaction=item.id
            this.drawer=false
            this.$store.commit('mdnavaction',item.id)
            this.$store.commit('active',null)
        },
        opennav(){
            this.drawer=true
        },
        axioslist(){
            this.$webhttp.get('v1/web/Index').then((res)=>{
                if(res.code==200){
                    this.list=res.data.resource
                    this.corelist=res.data.casesShow
                    this.data_change=res.data.digitals
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        botNavigation(item){
              this.$router.push({
                path: item.path,
                query:{
                    type:item.type
                }
            })
        },
        seedetails(item){
            this.$store.commit('mdnavaction',item.id)
            this.$router.push({
                path: item.path,
                query:{
                    id:item.id,
                    type:item.type
                }
            })
        },
        barclick(item){
            this.$store.commit('detailsbottom',true)
            this.$store.commit('mdnavaction',item.id)
            this.$store.commit('routerpath',item.id)
            this.$router.push({
                path: item.path,
                query:{
                    id:item.id
                }
            })
        }
    },

}
</script>
<style lang="less" scoped> 
/* 手机设备 */
@media (max-width:730px){
// @media (orientation: portrait){
    /deep/.el-drawer__wrapper{
        .el-drawer__container{
            .el-drawer{
                .el-drawer__header{
                    padding:7px 5px;
                    margin-bottom: 0px;
                }
            }

        }
    }
    .web_home{
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        .adaptation{
            display: none;
        }
       
        .md_box{     
            width: 100%;
            height: 100%;
            .md_content{
                box-sizing: border-box;
                height: 93.8%;
                overflow: scroll;
            }
            .md_nav_list{
                .md_nav_item{
                    height: 40px;
                    line-height: 40px;
                    padding-left: 20px;
                    font-weight: 400;
                    font-size: 17px;
                    color: #606060;
                    box-sizing: border-box;
                }
                .nav_active{
                    background: #027DFC;
                    font-weight: 400;
                    font-size: 17px;
                    color: #FFFFFF;
                }
            }
            .md_top_nav{
                position: relative;
                height: 58px;
                .img_box{
                    width: 85px;
                    height: 25px;
                    margin-top: 15px;
                    margin-left: 15px;
                }  
                .md_nav_img{
                    width: 25px;
                    height: 17px;
                    position: absolute;
                    top: 20px;
                    right: 25px;
                }
                
            }
          
        }
    
    }
}


/* pc设备 */
@media (min-width:730px) {
// @media screen and (min-width: 600px) {
     ::-webkit-scrollbar{
        display: none;
    }
    .web_home{
        width: 100%;
        height: 100%;
        min-width: 1905px;
        box-sizing: border-box;
        .pc_box{
            display: none;
        }
        .case_box{
            width: 100%;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;    
            position: relative;
            .case_title{
                font-size: 24px;
                font-weight: 400;
                color: #101010;;
                margin-bottom: 24px;
                margin-top: 120px;
                text-align: center;
            } 
            .swiper_left:hover,.swiper_right:hover{
                opacity: 0.5;
            }
            .swiper_left{
                position: absolute;
                background: #000;
                opacity: 0.3;
                left: 84px;
                top: 50%;
                margin-top: 24px;
                width: 48px;
                height: 48px;
                border-radius: 48px;
                display:flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }
            .swiper_right{
                cursor: pointer;
                position: absolute;
                background: #000;
                opacity: 0.3;
                top: 50%;
                margin-top: 24px;
                right: 98px;
                width: 48px;
                height: 48px;
                border-radius: 48px;
                display:flex;
                justify-content: center;
                align-items: center;
            }
            
            .swiper_two_box{
                box-sizing: border-box;
                margin-top: 30px;
                width: 84%;
                .swiper-slide:hover{
                    cursor: pointer;
                    .font_box{
                        border-left: 1px solid #3380FF;
                        border-right: 1px solid #3380FF;
                        border-bottom: 1px solid #3380FF;

                        .font_brief{
                            color: #101010;
                        }
                    }
                }
                .swiper-slide{
                    width: 380px !important;
                    height: 340px !important;
                    box-sizing: border-box;
                    position: relative;
                    .swiper_case_img{
                        box-sizing: border-box;
                        width: 380px;
                        height: 240px;
                    }
                .font_box{
                        position: absolute;
                        bottom: 0px;
                        width: 100%;
                        height: 100px;
                        border-left: 1px solid #D5D5D5;
                        border-right: 1px solid #D5D5D5;
                        border-bottom: 1px solid #D5D5D5;
                        padding:23px 20px;
                        box-sizing: border-box;
                        position: absolute;
                        .font_brief{
                            font-weight: 400;
                            font-size: 20px;
                            color: #606060;
                            line-height: 30px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2; /* 限制显示的行数为2 */
                            overflow: hidden;
                        }
                    }
                }
            
                .swiper-container {
                    width: 100%;
                    height: 100%;
                }
            
            }
        }
        .core_values{
            width:100%;
            box-sizing: border-box;
            padding: 0px 160px;
            .cv_item_box{
                display: flex;
                justify-content: space-around;
                .item_box{
                    box-sizing: border-box;
                    // border:1px solid #fff;
                    width: 300px;
                    height: 280px;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    flex-direction: column;
                    .item_content{
                        font-weight: 400;
                        font-size: 24px;
                        color: #606060;
                        text-align: center;
                        white-space: nowrap;
                    }
                    .item_top_box{
                        color: #004ea2;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        .core_font_box{
                            margin-top: 24px;
                            margin-bottom: 9px;
                            font-weight: 400;
                            font-size: 24px;
                            color: #101010;
                        }
                        .core_img_box{
                            width: 72px;
                            height: 72px;
                        }
                    }
                }
            }
            .cv_title{
                font-size: 24px;
                font-weight: 400;
                color: #333;
                margin-bottom: 37px;
                margin-top: 120px;
                text-align: center
            }
        }
        .pro_ana_ser{
            width:100%;
            box-sizing: border-box;
            .pas_item_box{
                box-sizing: border-box;
                background: #1B1E2D;
                width: 100%;
                height: 520px;
                padding:0px 160px;
            }
            .pas_title{
                font-size: 24px;
                font-weight: 400;
                color: #101010;;
                margin-bottom: 37px;
                margin-top: 119px;
                text-align: center
            }
            .pas_item_box{
                display: flex;
                justify-content: space-around;
                .box:hover{
                    cursor: pointer;
                    .two_box{
                        background: rgba(2,125, 252, 0.9);
                        .two_img_box{
                            transform: translate(0px,-140px);
                        }
                        .two_font{
                            transform: translate(0px,-140px);
                        }
                        .two_botton:hover{
                            color:#004ea2;
                            border: 0px;
                        }
                        .two_botton:hover::after {
                            top: -15px;
                            left: -15px;
                            right: -15px;
                            bottom: -15px;
                            border-color: #fff;
                            opacity: 0;
                        }
                        .two_botton::after{
                            content: "";
                            position: absolute;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            border: 2px solid transparent;
                            border-radius: 50px;
                            transition: all 0.5s ease;
                        }
                        .two_botton:hover::before{
                            width: 200px;
                            height: 54px;
                            transform: translate(-50%, -50%) scale(1);
                        }
                        .two_botton::before{  
                            content: "";
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            width: 150px;
                            height: 25px;
                            border-radius: 50px;
                            background: #fff;
                            transform: translate(-50%, -50%) scale(0);
                            transition: all 0.5s cubic-bezier(.3, 0, 0, 1.3);
                            z-index:-1 ;
                        }
                        .two_botton{
                            opacity: 1;
                            z-index: 1;
                            transform: translate(0px ,-100px);
                            font-size: 14px;
                        }
                        .two_font_title{
                            opacity: 1;
                            text-align: center;
                            width: 257px;
                            transform: translate(0px,-100px);
                            font-size: 16px;
                        }
                    }
                }
                .box{
                    width: 400px;
                    height: 520px;
                    border-radius: 5px;
                    box-sizing: border-box;
                    position: relative;
                    overflow: hidden;
                    .two_box{
                        width: 100%;
                        height: 100%;
                        // border: 1px solid black;
                        position: absolute;
                        top: 0px;      
                        right: 0px;
                        z-index: 2;
                        background: rgba(25, 25, 25, 0.6);
                        box-sizing: border-box;
                        .two_font_title{
                            opacity:0;
                            width: 257px;
                            height: 90px;
                            position: absolute;
                            text-align: left;
                            color: #fff;
                            top: 65%;
                            text-align: center;
                            left: 20%;
                            transition: all 0.5s ease;
                        }
                        .two_botton{
                            width: 200px;
                            height: 54px;
                            border-radius: 50px;
                            position: absolute;
                            font-size: 26px;
                            text-align: left;
                            border: 1px solid #fff;
                            color: #fff;
                            top: 90%;
                            right: 23%;
                            opacity: 0;
                            text-align: center;
                            line-height: 54px;
                            transition: all 0.5s ease-in-out;
                            z-index: 1;
                        
                        }
                        .two_font{
                            transition: 1s;
                            color: #fff;
                            font-weight: bold;
                            position: absolute;
                            top: 60%;
                            box-sizing: border-box;
                            text-align: center;
                            width: 100%;
                            transition: all 0.5s ease;
                        }
                        .two_img_box{ 
                            transition: 1s;
                            position: absolute;
                            top: 50%;
                            right: 50%;
                            width: 60px;
                            height: 60px;
                            margin-top: -30px;
                            margin-right: -30px;
                            transition: all 0.5s ease;
                            
                        }
                    }
                    .img_box{
                        width: 100%;
                        height: 100%;
                        border-radius: 5px;
                        box-sizing: border-box;
                        z-index: 1;
                    }
                }
            }
        }
        .homepage{
            box-sizing: border-box;
            width: 100%;
            height: 560px;
            padding: 0px 160px;
            .web_index_img_box{
                // width: 1600px;
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                background: url('../../assets/icons/官网首页_slices/宣传图.png') no-repeat;
                background-size: 100% 100%;
            }
        }
        .data_change{
            position: relative;
            width: 100%;
            height: 340px;
            box-sizing: border-box;
            padding:0px 160px;
            display: flex;
            justify-content: space-around;
            .data_item_box{
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                .count_box{
                    font-weight: bold;
                    line-height: 50px;
                    font-weight: 600;
                    font-size: 48px;
                    color: #027DFC;
                }
                .title{
                    font-weight: 500;
                    font-size: 16px;
                    color: #101010;
                    margin-top: 22px;
                }
                .little_title{
                    font-weight: 400;
                    font-size: 16px;
                    color: #606060;
                    margin-top: 8px;
                }
            }
        }
        .swiper_box{
            position: relative; 
            width: 100%;
            height: 640px;
            box-sizing: border-box;
            .swiper_top_box{
                width: 100%;
                height: 100%;
                .swiper-pagination .swiper-pagination-bullet {
                    display: inline-block;
                    width: 88px;
                    height: 4px;
                    background: #FFFFFF;
                    border-radius: 2px;
                    opacity: 0.5;
                    z-index: 2;
                }
                .swiper-pagination .swiper-pagination-bullet-active {
                width: 88px;
                    height: 4px;
                    background: #FFFFFF;
                    border-radius: 2px;
                    display: inline-block;
                    opacity: 1;

                    z-index: 2;
                }
                .swiper-container {
                    width: 100%;
                    border-radius: 5px;
                    padding-bottom: 2.5rem;
                }
                .swiper-slide {
                    text-align: center;
                    // margin: 0 -20px;
                    position: relative;
                    z-index: 1;
                    img {
                        width:100%;
                        height: 100%;
                    }
                }
            }
            .swiper_bar_box{    
                // border: 1px solid black;
                width: 100%;
                box-sizing: border-box;
                z-index: 99;
                position: absolute;
                top: 0px;
                .bar_box{
                    box-sizing: border-box;
                    position: absolute;
                    top: 39px;
                    right: 160px;
                    color: #fff;
                    font-weight: 400;
                    font-size: 16px;
                    display: flex;
                    .bar_botton{
                        height: 35px;
                        line-height: 35px; 
                        opacity: 0.6;
                    }
                    .bar_botton_magrin:not(:last-child){margin-right: 39px;}

                    .bar_botton:hover{
                        opacity: 1;
                        color: #fff;
                        border-bottom: 2px solid #027DFC;
                        cursor: pointer;
                        box-sizing: border-box;
                    }
                }
                .company_logo{
                    box-sizing: border-box;
                    position: absolute;
                    width: 120px;
                    height: 33px;
                    top: 24px;
                    left: 160px;
                    // .img_logo{
                    //     width: 48px;
                    //     height: 48px;
                    //     background: #fff;
                    //     border-radius: 50px;
                    // }
                    // .company_title{
                    //     font-size: 34px;
                    //     font-weight: bold;
                    //     color: #fff;
                    //     position: absolute;
                    //     top: 5px;
                    //     left: 70px;
                    // }
                }
            }
        }
        .el-carousel__item h3 {
            color: #475669;
            font-size: 14px;
            opacity: 0.75;
            line-height: 150px;
            margin: 0;
        }

        .el-carousel__item:nth-child(2n) {
            background-color: #99a9bf;
        }
        
        .el-carousel__item:nth-child(2n+1) {
            background-color: #d3dce6;
/* 针对纵向手机设备 */ 
        }
        .top{
            width: 100%;
            height: 56px;
            display: flex;
            justify-content: center;
            background: #1C3451;
            .btp{
                width: 70%;
                height: 56px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .catalogue{
                    width: 55%;
                    height: 56px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    text-align: center;
                    .category{
                        width: 20%;
                        height: 56px;
                        line-height: 56px;
                        box-sizing: border-box;
                        color:#F4F6FA ;
                        font-size: 16px;
                        font-weight: 400;
                    }
                    .selecte{
                        background: #2483C6;
                    }
                }
                .catalogue :hover{
                    background: #2483C6;
                    cursor: pointer;
                }
                .login{
                    width: 155px;
                    height: 27px;
                    cursor: pointer;
                }
            }
        }
        .bottom{
            width: 100%;
            height: 280px;
            background: #1B1E2D;
            box-sizing: border-box;
            position: relative;
            .authorize{
                display: flex;
                justify-content: center;
                .nat_box{
                    display: flex;
                    align-content: center;
                    .nat_img_box{
                        width: 18px;
                        height: 18px;
                        margin-right: 5px;
                    }
                }
                .por{
                    font-weight: 400;
                    color: #909090;
                    font-size: 14px;
                    width: 732px;
                    display: flex;
                    justify-content: space-between;
                    position: absolute;
                    bottom: 14px;
                    a{
                        color: #909090;
                    }
                }
            }
            .bottom_interior{
                box-sizing: border-box;
                width: 100%;
                height: 89%;
                display: flex;
                .unfold{
                    margin-left: 400px;
                }
                .news{
                    margin-left: 300px;
                }
                .about{
                    margin-left: 322px;
                }
                .contact{
                    width: 55%;
                }
                .unveil{
                    height: 100%;
                    box-sizing: border-box;
                    padding-top: 20px;
                    .title{
                        font-weight: 500;
                        font-size: 20px;
                        color: #FFFFFF;
                        line-height: 40px;
                    }
                    .increase{
                        padding-top: 15px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                    }
                    .subtitle{
                        cursor: pointer;
                        padding-top: 15px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        opacity: 0.6;
                    }
                    .subtitle:hover{
                        color: #FFFFFF;
                        opacity:1;
                    }
                }
            }
        }
    }
}

</style>